import { useEffect } from "react";

export function useSeo(title, jsonLd) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    if (title) document.title = `${title} · Pancham Dham`;
    if (!ld) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = ld;
    document.head.appendChild(el);
    return () => el.remove();
  }, [title, ld]);
}

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
